export const getFileData = message => message?.payload || message
